"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireDefault(require("react"));

var _SEMContact = _interopRequireDefault(require("./../../SEMContact"));

var _SEMSceneChange = _interopRequireDefault(require("./../SEMSceneChange"));

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

function SMEFreeTabCard(props) {
  var _a = props.contactUsData,
      contactUsData = _a === void 0 ? {} : _a,
      style = props.style,
      _b = props.tabCardData,
      tabCardData = _b === void 0 ? {} : _b;
  return /*#__PURE__*/_react["default"].createElement("section", {
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement(_SEMContact["default"] // pcBackgroundImage={
  //   'https://staticintl.cloudcachetci.com/cms/backend-cms/9c1385517cbc8860981a2e72e3ad310f16315870761447090.png'
  // }
  // mbBackgroundImage={
  //   'https://main.qcloudimg.com/qcintl-cms/154/1621394243622/a0b64dc365da68439ea2f96d9e37869d.pic_hd'
  // }
  // title={'Web Hosting'}
  // subhead={'Genral'}
  // content={
  //   'Tencent Cloud TStack is an enterprise-grade privatized full-stack cloud solution designed and refined by Tencent during the rapid development of its internet businesses. It provides integrated IaaS, PaaS, and SaaS cloud services that meet the needs of popular architectures. '
  // }
  // extendProps={{ aa: 's' }}
  // buttonConfig={[
  //   {
  //     extendProps: { aa: 's1' },
  //     txt: 'Learn more',
  //     href: 'www',
  //     onCallback: '点击事件1',
  //     colType: 'ghost',
  //     text: 'Learn more',
  //     'text-icon': '文字+图标',
  //     sizeType: 'large',
  //     alignType: 'center',
  //   },
  //   {
  //     tintType: true,
  //     extendProps: { aa: 's2' },
  //     txt: 'Apply Now',
  //     href: 'www',
  //     onCallback: '点击事件2',
  //     colType: 'transparent',
  //     text: 'Apply Now',
  //     'text-icon': '文字+图标',
  //     sizeType: 'large',
  //     alignType: 'center',
  //   },
  // ]}
  , __assign({}, contactUsData)), /*#__PURE__*/_react["default"].createElement(_SEMSceneChange["default"], __assign({}, tabCardData)));
}

var _default = SMEFreeTabCard;
exports["default"] = _default;